var map = {
	"./bootstrap.svg": 2376,
	"./css.svg": 1158,
	"./figma.svg": 6297,
	"./firebase.svg": 367,
	"./github.svg": 6729,
	"./html5.svg": 1730,
	"./javascript.svg": 4723,
	"./nodejs.svg": 2565,
	"./nuxt.svg": 2889,
	"./react.svg": 5640,
	"./sass.svg": 8671,
	"./tailwindcss.svg": 6212,
	"./vuejs.svg": 3207,
	"./vuetify.svg": 6346
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2994;